import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import roleManagementAPI from '../apis/roleManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class RoleManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    name: '',
    status: '',
  }
  @observable roleList = []
  @action
  async onSearchRoleAction(params,pageNo,pageSize) {
    this.isFetching = true
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      this.roleList = []
      this.searchItem = params
      const response = await roleManagementAPI.searchAction(params,pageNo,pageSize)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          for (var i = 0; i < response.data.data?.content.length; i++) {
            response.data.data.content[i].status?response.data.data.content[i].statusName='Enable': response.data.data.content[i].statusName='Disable';
          }
          this.roleList = response.data.data?.content || []
          this.itemCount = response.data.data?.totalElements
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  @action
  onChangeRoleList(value){
    this.roleList=value
  }
  /*add user*/
  @action
  async onAddRoleAction(params){
    this.isFetching = true
    try {
      const response = await roleManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchRoleAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Error！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*edit user*/
  @observable detailsObj= null
  @action
  async onGetAction(id){
    this.isFetching = true
    try {
      const response = await roleManagementAPI.getAction(id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.detailsObj=response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  async onEditRoleAction(params,id){
    this.isFetching = true
    try {
      const response = await roleManagementAPI.editAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchRoleAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get all permission list*/
  @observable permissionList = {}
  /*get all permission list*/
  @action
  async getPermissionRoleAction(id) {
    this.isFetching = true
    try {
      this.permissionList = {}
      const response = await roleManagementAPI.getOwnedPermissionAction(id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.permissionList=response.data.data || {}
          this.changeTargetKeys('MENU')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  changeTargetKeys(value){
    var newArr=[]
    if(value==='OPERATION'){
      if(this.permissionList.hasOwnProperty('operation')) {
        this.flatTree(this.permissionList.operation,0).map(item => {
          return newArr.push(item.id)
        })
      }
      this.targetKeys=newArr
      this.oldArr=newArr
    } else if(value==='API'){
      if(this.permissionList.hasOwnProperty('api')){
        this.flatTree(this.permissionList.api,0).map(item=>{
          return newArr.push(item.id)
        })
      }
      this.targetKeys=newArr
      this.oldArr=newArr
    } else {
      if(this.permissionList.hasOwnProperty('menu')) {
        this.flatTree(this.permissionList.menu,0).map(item => {
          return newArr.push(item.id)
        })
      }
      this.targetKeys=newArr
      this.oldArr=newArr
    }
  }
  //add role permission
  @observable targetKeys = [];
  @observable oldArr = [];
  @action
  getRoleUserListData(value) {
    this.targetKeys=value
  }
  /*Permission*/
  @action
  async onAddPermissionAction(params,id){
    this.isFetching = true
    try {
      const response = await roleManagementAPI.addPermissionAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchRoleAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete role*/
  @action
  async onDeleteRoleAction(id) {
    this.isFetching = true
    try {
      const response = await roleManagementAPI.deleteAction(id);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchRoleAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Delete Failed！' + response.data.messageEn +'')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchRoleAction(this.searchItem,this.pageNo,this.pageSize)
  }
  @action
  onChangePageNo(){
    this.pageNo = 1;
  }
  //展开tree
  @action
  flatTree(nodes,parentId) {  //tree to arrif (!nodes || nodes.length === 0) return [];
    let result = [];
    function flatTreeFun(nodes, parentId) {
      if (!nodes || nodes.length === 0) return [];
      nodes.forEach(node => {
        result.push({
          id: node.id,
          parentId: parentId,
          name: node.name,
        });
        return flatTreeFun(node.children, node.id);
      });
    }
    flatTreeFun(nodes, parentId)

    return result
  }
}
